<template>
  <WidgetCard title="GRUNDUTBILDNING" subtitle="ATT GRANSKA, GODKÄNNA ELLER BEKRÄFTA">
    <v-data-table 
      hide-default-footer
      :headers="[
        {text: 'Avser', value: 'name', width: '150'},
        {text: 'Avtalstillhörighet', value: 'contractType', width: '129'},
        {text: 'Yrke', value: 'profession', width: '180', sortable: false},
        {text: 'Region', value: 'region', width: '180', sortable: false},
        {text: 'Status/Agerat', value: 'state', width: '180', sortable: false},
        {text: 'Datum', value: 'createdAt', sortable: false, width: '100'},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      class="mt-n2 clickable"
      :items="items"
      :items-per-page="-1"
      item-key="id"
      @click:row="clickedRow"
    >
      <!-- Application name header -->
      <template slot="item.name" slot-scope="props">
        <div style="width: 140px;">
          {{ props.item.name }} ({{ props.item.personalNumber | formatSecretPnr }})
        </div></template
      >
      <template slot="item.contractType" slot-scope="props">
        <div style="width: 115px;">
          {{ get(props, 'item.contractType', '') }}
        </div>
      </template>
      <template slot="item.profession" slot-scope="props">
        <div style="width: 170px;">
          {{ props.item.profession }}
        </div>
      </template>
      <template slot="item.region" slot-scope="props">
        <div style="width: 170px;">
          {{ props.item.region }}
        </div>
      </template>
      <template slot="item.state" slot-scope="props">
        <div style="width: 170px;">
          {{ props.item.state }}
        </div>
      </template>
      <!-- Application issued On header -->
      <template slot="item.createdAt" slot-scope="props">
        <span class="widget-normal" style="width: 100px;">{{ props.item.createdAt | date }}</span>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import API from '@/services/api'
import get from 'lodash/get'
import {mapGetters} from 'vuex'
import WidgetCard from '@/components/widgets/WidgetCard.vue'

// @group Widgets
// ApplicationApprentice component
export default {

  name: 'Applications',

  components: {
    WidgetCard
  },

  data: () => ({
    items: [],
    stateId: []
  }),

  watch: {  
    handledCasesAreVisible: {
      handler(val) {
        this.fetchWidgets()
      }
    }
  },

  computed: {
    ...mapGetters('basic', [
      'basicApplicationStates',
      'basicRegions',
      'getApprovedApplications',
      'confirmedAndApprovedByCompany',
      'getProfessionNameById'
    ]),
    ...mapGetters('currentuser', ['currentUser', 'handledCasesAreVisible'])
  },

  created() {
    this.fetchWidgets()
  },

  methods: {
    get,

    fetchWidgets() {
      this.items = []
      
      const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }

      Promise.all([
        API.educationWidget(params).then(result => result.data.rows).catch(() => []),
        API.widgetBooks(params).then(result => result.data.rows).catch(() => [])
      ]).then(rows => {
        this.items = [].concat.apply([], rows).map(row => this.parseRow(row))
      }).catch(() => {})
    },

    clickedRow(item) {
      let appId = 0
      if (!item.bookId && item.educationId) {
        API.listApplications({
          startAt: 0,
          sortBy: 'lastName',
          sortDesc: 'ASC',
          advSearch: {personalNumber: item.personalNumber},
          pageSize: 500
        })
          .then(response => {
            appId = response.data.rows.find(x => x.educationId == item.educationId).id
            this.$router.push({name: 'Application', params: {id: appId}}).catch(() => {})
          })
          .catch(error => {
            this.$nextTick(() =>
              this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: {tab: '3'}}).catch(() => {})
            )
          })
      } else {
        this.$nextTick(() =>
          this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: {tab: '3'}}).catch(() => {})
        )
      }
    },

    calculateState(item) {
      if(item.basicEducationCertificate) {
        if(item.basicEducationCertificate.approvedBy) {
          return "Godkänd"
        }

        if ( item.basicEducationCertificate.createdBy ) {
          const { firstName, lastName } = item.basicEducationCertificate.createdBy
          return `${ firstName } ${ lastName }`
        }
      }

      return "Väntar på godk."
    },

    getApprovedBy(row) {
      if(row.basicEducationCertificate)
      {
        const createdBy = row.basicEducationCertificate.createdBy || {}
        return `${createdBy.firstName || ''} ${createdBy.lastName || ''}`
      }

      const approvedByInstructor = row.approvedByInstructor || {}

      return `${approvedByInstructor.firstName || ''} ${approvedByInstructor.lastName || ''}`
    },

    parseRow(row) {
      row.person = row.person || {}
      row.region = row.region || {}
      row.profession = row.profession || {}

      let employmentType = []
            
      if( row.apprenticeships?.length ) {
        employmentType = row.apprenticeships
      }

      if( row.person?.employments?.length ) {
        employmentType = row.person?.employments
      }

      return {
        bookId: get(row, 'book.id', null),
        educationId: row.basicEducationCertificate ? row.id : null,
        state: this.calculateState(row),
        personalNumber: row.person.personalNumber || '',
        personId: row.person.id || '',
        profession: row.profession.name || '',
        contractType: employmentType[0]?.company?.contracttype?.name ?? '',
        name: `${row.person.firstName || ''} ${row.person.lastName || ''}`,
        region: row.region.name || '',
        basicEducationCertificate: row.basicEducationCertificate,
        createdAt: row.basicEducationCertificate ? (row.basicEducationCertificate.createdAt || '') : row.createdAt || '' 
      }
    }
  }
}
</script>

<style scoped>
</style>
